import React from 'react';
import swagLogoGreyImage from 'assets/img/swag-logo-grey.png';
import Button from '../../../../ui/button/index';
import classes from '../../kickstarter-shipping-popup.scss';
export default function KickstarterShippingProposals({
  onApprove,
  onClose
}) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("section", {
    className: classes.popupHeader
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.KSLabel
  }, "KICKSTARTER"), /*#__PURE__*/React.createElement("span", {
    className: classes.plusSign
  }, "+"), /*#__PURE__*/React.createElement("img", {
    className: classes.proposals_SWLabel,
    src: swagLogoGreyImage,
    alt: "swag logo"
  })), /*#__PURE__*/React.createElement("p", {
    className: classes.popupContent
  }, "Any friend of Kickstarter\u2019s is a friend of ours. You just got 20% off your order."), /*#__PURE__*/React.createElement("p", {
    className: classes.popupContent
  }, "As a Kickstarter creator, we can also offer you full-service fulfillment. That means we\u2019ll package and ship your t-shirts directly to your backers if you\u2019d like. The fulfillment fee is $8 for each US-based recipient, and $20 for each International recipient. Would you like us to handle fulfillment?"), /*#__PURE__*/React.createElement("div", {
    className: classes.popupActions
  }, /*#__PURE__*/React.createElement(Button, {
    className: classes.proposals_applyBtn,
    onClick: onApprove
  }, "Yes please"), /*#__PURE__*/React.createElement(Button, {
    className: classes.proposals_declineBtn,
    onClick: onClose
  }, "No, ship my shirts to me")));
}